var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.isLoading),expression:"isLoading",modifiers:{"body":true}}],class:[_vm.deviceClass],attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }